// extracted by mini-css-extract-plugin
export default {"toggle-button-group--separated":"ToggleButtonGroup_toggle-button-group--separated__NnkDv"};